import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import { PopUpContext } from "../../contexts/popUpContext";

class StudentDiscountPopUp extends Form {
  static contextType = PopUpContext;

  state = {
    drp: {
      employees: [],
      entryYears: [],
    },
    data: {
      discount_type_id: "",
      amount: "",
      issue_date: "",
      valid_from_entry_year_id: null,
      valid_until_entry_year_id: null,
      permanent: 0,
      remark: "",
      attachment: "",
    },
    errors: {},
  };

  componentDidMount = async () => {
    const { drp, data } = this.state;
    const {
      popUp: { edit },
    } = this.context;

    if (edit) {
      data.discount_type_id = edit.discount_type_id;
      data.amount = edit.amount;
      data.issue_date = edit.issue_date;
      data.valid_from_entry_year_id = edit.valid_from_entry_year_id;
      data.valid_until_entry_year_id = edit.valid_until_entry_year_id;
      data.permanent = edit.permanent;
      data.remark = edit.remark;
    }

    await db
      .getAll(`dropdowns/entryYears`)
      .then(({ data: { data } }) => (drp["entryYears"] = data));

    await db
      .getAll(`dropdowns/discountTypes`)
      .then(({ data: { data } }) => (drp["discounts"] = data));

    this.setState({ drp, data });
  };

  schema = {
    discount_type_id: Joi.number().required(),
    amount: Joi.number().required(),
    issue_date: Joi.date().required(),
    valid_from_entry_year_id: Joi.allow(null),
    valid_until_entry_year_id: Joi.allow(null),
    attachment: Joi.allow(null),
    permanent: Joi.any(),
    remark: Joi.allow(null),
  };

  doSubmit = async (e) => {
    const { togglePopUp, popUp } = this.context;

    let __controls = this.cleanObject({
      student_id: popUp?.cache,
      ...this.state.data,
    });

    try {
      await db
        .form("students/discounts", e.target, __controls, popUp?.edit?.id)
        .then(() => {
          togglePopUp({ form: "toast" });
        })
        .catch((e) => {
          togglePopUp({
            form: "toast",
            message: e.toString(),
            type: "warning",
          });
        });
    } catch ({ response }) {
      if (response && response.status === 400) {
        const errors = { ...this.state.error };

        console.log(errors);

        this.setState({ errors });
      }
    }
  };

  render() {
    const { drp } = this.state;
    const { popUp } = this.context;

    return (
      <div className="form-container">
        <form className="form crud" onSubmit={this.handleSubmit}>
          <div className="head">
            <p>{popUp?.edit ? lbl.EditDiscount : lbl.SaveDiscount}</p>
          </div>
          <div className="form-inputs">
            {this.renderSelect(
              "discount_type_id",
              "نوع تخفیف",
              drp["discounts"]
            )}
            {this.renderInput("amount", "مبلغ", "number")}
            {this.renderInput("issue_date", "تاریخ صدور", "date")}
            <div className="multi-date has-chk">
              {this.renderCheckBox("permanent", "مدت تخفیف", "دایمی")}
              {this.renderSelect(
                "valid_from_entry_year_id",
                "تاریخ اعتبار از",
                drp["entryYears"]
              )}
              {this.renderSelect(
                "valid_until_entry_year_id",
                "تا",
                drp["entryYears"]
              )}
            </div>

            {this.renderInput("remark", "ملاحظه", "textarea")}
            {this.renderFile("attachment", "سند")}
          </div>
          <div className="form-buttons">
            {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
          </div>
        </form>
      </div>
    );
  }
}

export default StudentDiscountPopUp;
